import type { Timestamp } from "firebase/firestore";

export type UserRole = "ADMIN" | "COADMIN" | "USER";

export type Section = {
  id: string;
  name: string;
  description?: string;
  imageUrl?: string | null;
  appHtml?: string;
  createdAt?: Timestamp;
};

export function isAppSection(section?: Section | null): section is Section & { appHtml: string } {
  return Boolean(section?.appHtml?.trim());
}

export type Post = {
  id: string;
  sectionId: string;
  targetId: string;
  targetType: "section" | "subforum";
  authorId: string;
  authorEmail: string;
  authorProfilePictureUrl?: string;
  authorRole: UserRole | string;
  title: string;
  content: string;
  imageUrl?: string | null;
  timestamp?: Timestamp;
  lastActivityTimestamp?: Timestamp;
  reviewStatus?: string;
  likes?: string[];
  likeCount?: number;
  commentCount?: number;
  isLocked?: boolean;
};

export type StoreItem = {
  id: string;
  name: string;
  description?: string;
  price?: number;
  imageUrl?: string | null;
};

export type ForumUser = {
  uid: string;
  email?: string;
  nickname?: string;
  profilePictureUrl?: string;
  role?: UserRole | string;
  managedSections?: string[];
  coins?: number;
  purchasedItems?: string[];
  displayedItems?: string[];
  following?: string[];
  followers?: string[];
  blockedUsers?: string[];
  collectedPosts?: string[];
};

export type LiveChatRoom = {
  id: string;
  name: string;
  description?: string;
  imageUrl?: string | null;
  lastMessage?: string;
  lastMessageAt?: number;
};

export type Comment = {
  id: string;
  postId: string;
  sectionId: string;
  authorId: string;
  authorEmail?: string;
  authorNickname?: string;
  authorProfilePictureUrl?: string;
  content: string;
  imageUrl?: string | null;
  timestamp?: Timestamp;
  likes?: string[];
  likeCount?: number;
};

export type Conversation = {
  id: string;
  participants: string[];
  lastMessage?: string;
  lastMessageSenderId?: string;
  lastMessageTimestamp?: Timestamp;
};

export type DirectMessage = {
  id: string;
  conversationId: string;
  senderId: string;
  receiverId: string;
  text: string;
  selectedItemIconUrl?: string | null;
  timestamp?: Timestamp;
};

export type ReviewPost = {
  post: Post;
  collectionName: string;
};
